export default __webpack_public_path__ + "static/media/thumb.f9e6c5ae.png";